"use client";

import { useEffect, useState } from "react";
import { getMessages, Locale } from "../lib/i18n";
import { useLanguageQuery } from "@/hooks/use-language";
type TranslationValue = string | string[] | Record<string, any> | undefined;

// const getLocaleFromCookie = (): Locale => {
//   const match = document.cookie.match(/rc_language_system=([^;]+)/);
//   return (match?.[1] as Locale) || "en";
// };

export const useTranslation = () => {
  const [locale, setLocale] = useState<Locale>("en");
  const [messages, setMessages] = useState(getMessages("en"));
  const { data, isLoading } = useLanguageQuery();

  useEffect(() => {
    const initiated = async () => {
      if (!data) return;
      setLocale(data);
      setMessages(getMessages(data));
    };

    initiated();
  }, [data]);

  const getNestedValue = (obj: Record<string, any>, path: string): TranslationValue => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  const t = (path: string, fallback?: string): string => {
    const value = getNestedValue(messages, path);

    if (typeof value === "string") return value;

    if (value === undefined) {
      return fallback ?? path;
    }

    return fallback ?? path;
  };

  const tm = <T = any>(path: string, fallback?: T): T => {
    const value = getNestedValue(messages, path);

    if (value === undefined) {
      return fallback as T;
    }

    return value as T;
  };

  const ti = (path: string, variables: Record<string, string | number>): string => {
    const template = t(path);

    return Object.keys(variables).reduce((result, key) => {
      return result.replace(new RegExp(`{{${key}}}`, "g"), String(variables[key]));
    }, template);
  };

  return { t, tm, ti, locale };
};
